import { Constants } from '../../../../constants';

export const newBrandStatus = (currentStatus, newStatus) => {
  const isAlreadyActive = currentStatus === Constants.BrandStatus.Active;
  const isAttemptingInactive = newStatus === Constants.BrandStatus.Inactive;
  if (isAlreadyActive || isAttemptingInactive) return currentStatus;
  return newStatus;
};
